import About from './About';
import Contact from './Contact';
import Home from './Home';
import { Link } from 'react-router-dom';
import './FooterLink.css'


function FooterLinks(){
    return(
         <div>
             <ul>
                 <li className="ListItems" ><span><Link to="/" className="LinkItem">Home</Link></span> </li>
                 <li className="ListItems"><span><Link to="/about"  className="LinkItem"> About</Link> </span></li>
                 <li className="ListItems" ><span><Link to="/frequently" className="LinkItem">Frequently</Link></span> </li>
                 <li className="ListItems"><span><Link to="/contact" className="LinkItem">Contact</Link></span> </li>

</ul>

</div>

)

}

export default FooterLinks;